import { action, observable, runInAction } from 'mobx';
import cloneDeep from 'lodash/cloneDeep';

import { ErrorInterface } from 'modules/core/api/globalApi';
import { tireStorageController } from './tireStorageController';
import {
  TireBrandInterface,
  TireModelInterface,
  AddNewTireBrandRequestInterface,
  AddNewTireModelRequestInterface,
} from '../../api/tireStorageApi';

type TireModelsCacheType = {
  tireModels: TireModelInterface[],
  brandId: number,
};
export interface TireStorageStore {
  tireBrands: TireBrandInterface[],
  axle1TireModels: TireModelInterface[], // для 1-ой оси модели шин
  axle2TireModels: TireModelInterface[], // для 2-ой оси модели шин
  axle1TireModelByBrandId: number,
  axle2TireModelByBrandId: number,
  tireModelsCache: TireModelsCacheType[],
  error: ErrorInterface,
}

export const tireStorageStore: TireStorageStore = observable({
  tireBrands: [],
  axle1TireModels: [],
  axle2TireModels: [],
  axle1TireModelByBrandId: undefined,
  axle2TireModelByBrandId: undefined,
  tireModelsCache: [],
  error: null,
} as TireStorageStore);

export const tireStorageActions = {

  // Устраревший STORE - планирую удалить до весны 2025 года
  // 26.11.2024 на совещании с Николаем решили, что справочники марок и моделей шин будем заводить через 1С
  // меняется логика - делается новый контроллер на бэке для шин с поддержкой 1С

  getTireBrands: async (useCache: boolean = true): Promise<void> => {
    if (tireStorageStore.tireBrands.length === 0 || !useCache) {
      tireStorageStore.error = null;
      const response = await tireStorageController.getTireBrandsResponse(false);
      tireStorageActions.handleError(response);
      runInAction(() => { tireStorageStore.tireBrands = response.data; });
    }
  },

  addNewTireBrand: async (request: AddNewTireBrandRequestInterface): Promise<number> => {
    const response = await tireStorageController.addNewTireBrand(request);
    if (response.errorData) {
      tireStorageActions.handleError(response);
      return 0;
    }
    tireStorageStore.tireBrands = [...tireStorageStore.tireBrands, response.data];
    return response?.data?.id;
  },

  /* clearTireBrands: action(() => {
    tireStorageStore.tireBrands = null;
  }), */

  getTireModels: async (
    brandId: number,
    tireModelsField: string,
    tireModelByBrandIdField: string,
    useCache: boolean = true
  ): Promise<void> => {
    tireStorageStore.error = null;
    runInAction(() => { tireStorageStore[tireModelByBrandIdField] = brandId; });
    const tireModels = tireStorageStore.tireModelsCache.find((v) => v.brandId === brandId)?.tireModels ?? null;
    if (tireModels && useCache) {
      runInAction(() => { tireStorageStore[tireModelsField] = cloneDeep(tireModels); });
    } else {
      const response = await tireStorageController.getTireModelsResponse(false, brandId);
      if (response.errorData) {
        tireStorageActions.handleError(response);
        tireStorageActions.clearTireModels(tireModelsField, tireModelByBrandIdField);
      } else {
        runInAction(() => { tireStorageStore[tireModelsField] = response.data; });
        tireStorageStore.tireModelsCache.push({ tireModels: response.data, brandId });
      }
    }
  },

  addNewTireModel: async (
    request: AddNewTireModelRequestInterface,
    tireModelsField: string
  ): Promise<number> => {
    const response = await tireStorageController.addNewTireModel(request);
    if (response.errorData) {
      tireStorageActions.handleError(response);
      return 0;
    }
    tireStorageStore[tireModelsField] = [...tireStorageStore[tireModelsField], response.data];
    // в кеше обновим данные:
    tireStorageStore.tireModelsCache = tireStorageStore.tireModelsCache
      .filter((v) => v.brandId !== request.tireBrandId);
    tireStorageStore.tireModelsCache.push({
      tireModels: tireStorageStore[tireModelsField],
      brandId: request.tireBrandId,
    });
    // конец обновления кеша
    return response?.data?.id;
  },

  clearTireModels: action((
    tireModelsField: string,
    tireModelByBrandIdField: string
  ) => {
    tireStorageStore[tireModelsField] = [];
    tireStorageStore[tireModelByBrandIdField] = null;
  }),

  handleError: action((response) => {
    if (response.errorData) {
      const { data } = response;
      tireStorageStore.error = data;
      throw data;
    }
  }),

};
